export default {"src":"/_next/static/media/bottom-l.8ef6a631.svg","height":300,"width":73,"blurWidth":0,"blurHeight":0};